import axios from 'axios';
import { isValidTokenFormat } from '../utils/tokenUtils';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const AUTH_ENDPOINT = process.env.REACT_APP_AUTH_ENDPOINT || '/auth';
export const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY || 'moftah_auth_token';

// Debug environment variables
console.log('API URL:', API_URL);
console.log('AUTH ENDPOINT:', AUTH_ENDPOINT);

// Create axios instance
const api = axios.create({
  baseURL: API_URL
});

// Add request interceptor to attach the token to all requests
api.interceptors.request.use(config => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Login user
export const login = async (username, password) => {
  console.log('Login attempt for:', username);
  console.log('Calling endpoint:', `${API_URL}${AUTH_ENDPOINT}/login`);
  
  try {
    const response = await api.post(`${AUTH_ENDPOINT}/login`, { username, password });
    
    console.log('Login response:', response.data);
    
    // Store token in localStorage if needed
    if (response.data.token) {
      const token = response.data.token;
      console.log('Token received:', token.substring(0, 20) + '...');
      console.log('Full token length:', token.length);
      console.log('TOKEN_KEY being used:', TOKEN_KEY);
      
      // Check if token is valid before storing it
      if (isValidTokenFormat(token)) {
        localStorage.setItem(TOKEN_KEY, token);
        
        // Verify storage worked
        const storedToken = localStorage.getItem(TOKEN_KEY);
        console.log('Stored token verification:', storedToken ? `${storedToken.substring(0, 20)}... (length: ${storedToken.length})` : 'Failed to store');
        
        console.log('Valid token stored in localStorage');
      } else {
        console.error('Received invalid token format from server');
        throw new Error('Invalid token format received from server');
      }
    } else {
      console.error('No token received in login response');
    }
    
    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

// Register new user
export const register = async (username, password, role) => {
  try {
    const response = await api.post(`${AUTH_ENDPOINT}/register`, { 
      username, 
      password, 
      role 
    });
    return response.data;
  } catch (error) {
    console.error('Registration error:', error);
    throw error;
  }
};

// Logout user - clear token from localStorage
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  console.log('Token removed from localStorage');
};

// Check if user is authenticated (token exists)
export const isAuthenticated = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    console.log('No token found in localStorage');
    return false;
  }
  
  // Use the tokenUtils validator instead of manual validation
  if (!isValidTokenFormat(token)) {
    console.log('Invalid token format detected in isAuthenticated');
    localStorage.removeItem(TOKEN_KEY);
    return false;
  }
  
  return true;
};
